export const DEALS = {
  INDEX: 'dealsSlide',
  FUTURE_DEALS: 'futureDeals',
  PAST_DEALS: 'pastDeals',
};

export const SLIDES = {
  INDEX: 'slides',
};
